// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"49":"component---src-pages-about-tsx","218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"49":"a730ed038c8a655b50bd","218":"ea6791b47dd8d5a40d74","351":"c60ae0d8c40f0684622c","691":"ac82098a757933a13c39"}[chunkId] + ".js";
};